__turbopack_context__.v({
  "simulation-card-wrapper": "y1GB5a_simulation-card-wrapper",
});
